import React, { 
  createContext,
  useContext,
  useEffect,
  useState,
} from 'react'

const ScaleContext = createContext(1)

export const useScale = () => useContext(ScaleContext)

export const ScaleProvider = ({ children }) => {
  const BASE_WIDTH = 1440
  const BASE_HEIGHT = 529
  const [scale, setScale] = useState(1)

  useEffect(() => {
    const updateScale = () => {
      const widthScale = window.innerWidth / BASE_WIDTH
      const heightScale = window.innerHeight / BASE_HEIGHT
      setScale(Math.min(widthScale, heightScale))
    }
    updateScale()
    window.addEventListener('resize', updateScale)
    return () => window.removeEventListener('resize', updateScale)
  }, [])

  return (
    <ScaleContext.Provider value={scale}>
      {children}
    </ScaleContext.Provider>
  )
}
